import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Navbar, Nav } from 'react-bootstrap';
import { FaHome, FaUserPlus, FaHandsHelping, FaMapMarkerAlt } from 'react-icons/fa';
import Joyride from 'react-joyride';
import {
  HeroContainer,
  HeroBg,
  VideoBg,
  HeroContent,
  HeroBtnWrapper,
  ArrowForward,
  ArrowRight,
} from "./HomeElements";
import { ButtonR } from "../ButtonElements";

import "../../App.css";
import { useAuth } from '../../Context/AuthContext';
import { useNavigate } from 'react-router-dom';

const HomePage = () => {
  const [hover, setHover] = useState(false);
  const [run, setRun] = useState(false);
  const { user, loading } = useAuth(); 
  const navigate = useNavigate();
  useEffect(() => {
    const timer = setTimeout(() => {
      setRun(true);
    }, 300);
    return () => clearTimeout(timer);
  }, []);

  const onHover = () => {
    setHover(!hover);
  };
  const handleClick = () => {
    if (loading) return; // Prevent navigation while loading
  
    const userData = JSON.parse(localStorage.getItem('userData'));
    const shelterId = userData?.shelter?.id;
  
   
    if (user?.isAdmin && !shelterId) {
      navigate('/admin/addshelter');
     
    } else if (user?.isAdmin) {
      navigate('/admin/dashboard');
    } else if (user?.isRefugee) {
      navigate('/dashboard');
    } else if (user?.isState) {
      navigate('/state/dashboard');
    } else {
      navigate('/signin');
    }
  };
  
  
  if (loading) {
    return null;
  }


  return (
    <>

    
   {/* Hero Section */}
<section className="hero-section text-white text-center position-relative">
  {/* Background video */}
  <video
    autoPlay
    muted
    loop
    playsInline
    className="position-absolute w-100 h-100 object-fit-cover"
    style={{ top: 0, left: 0, zIndex: -1, opacity: 0.4 }}
  >
    <source src="/videos/hero-background.mp4" type="video/mp4" />
    Your browser does not support the video tag.
  </video>

  {/* Content */}
  <div className="hero-content container py-5">
    <h1 className="display-3 fw-bold">Welcome to Our Shelter</h1>
    <p className="lead mb-4">Providing a safe haven and support for those in need.</p>
    <div>
      <ButtonR
        to="#"
        onMouseEnter={onHover}
        onMouseLeave={onHover}
        primary="true"
        dark="true"
        onClick={handleClick}
        className="main-button"
      >
        Get started {hover ? <ArrowForward /> : <ArrowRight />}
      </ButtonR>
    </div>
  </div>
</section>

      {/* Features */}
      <section className="features-section bg-black text-light position-relative">
  {/* SVG Top Curve */}
  <div className="svg-top">
  <svg viewBox="0 0 1440 320" preserveAspectRatio="none">
  <path
    fill="#0e0e0e"  
    fillOpacity="1"
    d="M0,64L80,80C160,96,320,128,480,128C640,128,800,96,960,106.7C1120,117,1280,171,1360,197.3L1440,224L1440,0L1360,0C1280,0,1120,0,960,0C800,0,640,0,480,0C320,0,160,0,80,0L0,0Z"
  />
</svg>


</div>


<Container className="py-5">
  <Row className="text-center mb-4">
    <h2 className="fw-bold text-white">What We Offer</h2>
  </Row>
  <Row className="text-center">
    <Col md={4} className="mb-4">
      <FaUserPlus size={40} className="mb-3 text-green" />
      <h4>User Identification</h4>
      <p>Secure login using unique user ID for personalized access and tracking.</p>
    </Col>
    <Col md={4} className="mb-4">
  <FaMapMarkerAlt size={40} className="mb-3 text-green" />
  <h4>Presence Monitoring</h4>
  <p>We ensure that the user remains safely within the shelter premises at all times.</p>
</Col>

    <Col md={4} className="mb-4">
      <FaHandsHelping size={40} className="mb-3 text-green" />
      <h4>Room Assignment</h4>
      <p>Get assigned to suitable rooms in shelters based on your needs and availability.</p>
    </Col>
  </Row>
</Container>

</section>

    
      {/* Footer */}
    
      <footer/>
    </>
  );
};

export default HomePage;
